import { render, staticRenderFns } from "./DeleteService.vue?vue&type=template&id=1d3bb592&scoped=true&lang=pug&"
import script from "./DeleteService.vue?vue&type=script&lang=js&"
export * from "./DeleteService.vue?vue&type=script&lang=js&"
import style0 from "./DeleteService.vue?vue&type=style&index=0&id=1d3bb592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3bb592",
  null
  
)

export default component.exports